import { FC } from "react";

export const Logout: FC = () => {
  const handleLogout = () => {
    // Cloudflare Access のセッションを破棄する
    window.location.href = "/cdn-cgi/access/logout";
  };

  return (
    <div className="">
      <button
        onClick={handleLogout}
        className="w-full py-2 px-4 bg-red-600 hover:bg-red-700 rounded text-white transition-colors"
      >
        ログアウト
      </button>
    </div>
  );
};
